// this isn't a module, so we make it one
// importing like this attaches it to the window object
const WebAudioFontPlayer = window.WebAudioFontPlayer;

// take that and use it like an import/export elsewhere
export { WebAudioFontPlayer };
